'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleProvider = undefined;

var _defaults = require('./defaults');

var _defaults2 = _interopRequireDefault(_defaults);

var _rulesBuilder = require('./rules-builder');

var _rulesBuilder2 = _interopRequireDefault(_rulesBuilder);

var _componentBuilder = require('./component-builder');

var _componentBuilder2 = _interopRequireDefault(_componentBuilder);

var _styleProvider = require('./style-provider');

var _styleProvider2 = _interopRequireDefault(_styleProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _componentBuilder2.default)((0, _rulesBuilder2.default)(_defaults2.default));
exports.StyleProvider = _styleProvider2.default;


//////////////////
// WEBPACK FOOTER
// ./~/reta/index.js
// module id = 620
// module chunks = 0